import { CONTENT_PAGES } from 'features/empty_state'

import adminDashboardSide from './assets/admin_dashboard_side.svg'
import analyticsEventsSide from './assets/analytics_events_side.svg'
import analyticsMeetingsSide from './assets/analytics_meetings_side.svg'
import analyticsRoutingSide from './assets/analytics_routing_side.svg'
import blockedSourcesIcon from './assets/blocked_sources_icon.svg'
import contactsSide from './assets/contacts_side.svg'
import eventTypesIcon from './assets/event_types_icon.svg'
import groupsIcon from './assets/groups_icon.svg'
import managedEventTypesIcon from './assets/managed_ets_icon.svg'
import managedWorkflowsIcon from './assets/managed_workflows_icon.svg'
import meetingTypesSide from './assets/meeting_types_side.svg'
import meetingsSide from './assets/meetings_side.svg'
import pollsIcon from './assets/polls_icon.svg'
import recapsIcon from './assets/reacps_icon.svg'
import routingFormsIcon from './assets/routing_forms_icon.svg'
import singleUseLinksIcon from './assets/single_use_links_icon.svg'
import usersIcon from './assets/users_icon.svg'
import workflowsIcon from './assets/workflows_icon.svg'

// These are the possible values to pass in to the type prop
// <EmptyState type="value_goes_here" />
const EMPTY_STATE_CENTERED_TYPE = 'centered'
const EMPTY_STATE_LEFT_RIGHT_TYPE = 'left_right'
const EMPTY_STATE_PREVIEW_TYPE = 'preview'
const EMPTY_STATE_TEMPLATES_TYPE = 'templates'

export const EMPTY_STATE_TYPES = {
  centered: EMPTY_STATE_CENTERED_TYPE,
  leftRight: EMPTY_STATE_LEFT_RIGHT_TYPE,
  preview: EMPTY_STATE_PREVIEW_TYPE,
  templates: EMPTY_STATE_TEMPLATES_TYPE
}

export const EMPTY_STATE_ICON_MAP = {
  [CONTENT_PAGES.adminDashboard]: adminDashboardSide,
  [CONTENT_PAGES.analyticsEvents]: analyticsEventsSide,
  [CONTENT_PAGES.analyticsMeetings]: analyticsMeetingsSide,
  [CONTENT_PAGES.analyticsRouting]: analyticsRoutingSide,
  [CONTENT_PAGES.contacts]: contactsSide,
  [CONTENT_PAGES.eventTypes]: eventTypesIcon,
  [CONTENT_PAGES.groups]: groupsIcon,
  [CONTENT_PAGES.managedEventTypes]: managedEventTypesIcon,
  [CONTENT_PAGES.managedWorkflows]: managedWorkflowsIcon,
  [CONTENT_PAGES.meetings]: meetingsSide,
  [CONTENT_PAGES.meetingTypes]: meetingTypesSide,
  [CONTENT_PAGES.routingForms]: routingFormsIcon,
  [CONTENT_PAGES.users]: usersIcon,
  [CONTENT_PAGES.workflows]: workflowsIcon,
  [CONTENT_PAGES.recapsMIEnabled]: recapsIcon,
  [CONTENT_PAGES.singleUseLinks]: singleUseLinksIcon,
  [CONTENT_PAGES.polls]: pollsIcon,
  [CONTENT_PAGES.blockedSources]: blockedSourcesIcon,
}

export const CONTENT_PAGES_WITHOUT_CTA = [CONTENT_PAGES.workflows, CONTENT_PAGES.managedWorkflows]
export const CONTENT_PAGES_WITH_DROPDOWN = [CONTENT_PAGES.eventTypes]
export const CONTENT_PAGES_WITH_TITLE_TEXT = [CONTENT_PAGES.blockedSources]
export const EYEBROW_TEXT = [
  CONTENT_PAGES.adminDashboard,
  CONTENT_PAGES.analyticsEvents,
  CONTENT_PAGES.analyticsMeetings,
  CONTENT_PAGES.analyticsRouting,
]

export const EVENT_TYPES_PATH = '/event_types/user/me'
export const ADMIN_INVITE_PATH = '/app/admin/invitations/new'

export const ANALYTICS_CTA_CLICK_PROPS_MAP = {
  [CONTENT_PAGES.adminDashboard]: {
    cta_key: 'empty_state_admin_dash',
    cta_text: 'invite_teammate',
    cta_destination: 'invite_teammate_flow'
  },
  [CONTENT_PAGES.analyticsEvents]: {
    cta_key: 'empty_state_analytics_events',
    cta_text: 'book_your_first_meeting',
    cta_destination: 'et_page'
  },
  [CONTENT_PAGES.analyticsMeetings]: {
    cta_key: 'empty_state_analytics_capacity',
    cta_text: 'book_your_first_meeting',
    cta_destination: 'et_page'
  },
  [CONTENT_PAGES.analyticsRouting]: {
    cta_key: 'empty_state_analytics_routing',
    cta_text: 'add_routing_form',
    cta_destination: 'routing_form_creation_flow'
  },
  [CONTENT_PAGES.contacts]: {
    cta_key: 'empty_state_contacts',
    cta_text: 'book_your_first_meeting',
    cta_destination: 'et_page'
  },
  [CONTENT_PAGES.groups]: {
    cta_key: 'empty_state_admin_user_groups',
    cta_text: 'new_group',
    cta_destination: 'user_group_creation_flow'
  },
  [CONTENT_PAGES.managedEventTypes]: {
    cta_key: 'empty_state_admin_managed_events',
    cta_text: 'new_managed_event',
    cta_destination: 'managed_event_creation_flow'
  },
  [CONTENT_PAGES.managedWorkflows]: {
    cta_key: 'empty_state_admin_managed_workflows',
    cta_text: 'new_managed_workflow',
    cta_destination: 'managed_workflow_creation_flow'
  },
  [CONTENT_PAGES.meetings]: {
    cta_key: 'empty_state_meetings',
    cta_text: 'book_your_first_meeting',
    cta_destination: 'et_page'
  },
  [CONTENT_PAGES.recaps]: {
    cta_key: 'ai_notetaker_recaps_page_entry_point',
    cta_text: 'get_started_ai_notetaker',
    cta_destination: 'ai_notetaker_setup_flow'
  },
  [CONTENT_PAGES.sampleRecap]: {
    cta_key: 'ai_notetaker_sample_recap_entry_point',
    cta_text: 'enable_meetings_recap',
    cta_destination: 'ai_notetaker_setup_flow'
  },
  [CONTENT_PAGES.recapsMIEnabled]: {
    cta_key: 'empty_state_recaps',
    cta_text: 'schedule_meeting',
    cta_destination: 'event_types_page'
  },
  [CONTENT_PAGES.routingForms]: {
    cta_key: 'empty_state_routing',
    cta_text: 'new_routing_form',
    cta_destination: 'routing_form_creation_flow'
  },
  [CONTENT_PAGES.users]: {
    cta_key: 'empty_state_admin_users',
    cta_text: 'invite_teammate',
    cta_destination: 'invite_teammate_flow'
  },
  [CONTENT_PAGES.workflows]: {
    cta_key: 'empty_state_workflows',
    cta_text: 'add_workflow',
    cta_destination: null // Per workflow, handled onClick
  },
}

const buildFlowStartedProps = (context, path) => ({
  flow_name: `contextual_help_${context}`,
  flow_location: `empty_state_${context}`,
  flow_version: 'v1',
  path
})
export const ANALYTICS_FLOW_STARTED_PROPS_MAP = {
  [CONTENT_PAGES.adminDashboard]: (path) => buildFlowStartedProps('admin_dashboard', path),
  [CONTENT_PAGES.analyticsEvents]: (path) => buildFlowStartedProps('analytics_events', path),
  [CONTENT_PAGES.analyticsMeetings]: (path) => buildFlowStartedProps('analytics_capacity', path),
  [CONTENT_PAGES.analyticsRouting]: (path) => buildFlowStartedProps('analytics_routing', path),
  [CONTENT_PAGES.contacts]: (path) => buildFlowStartedProps('contacts', path),
  [CONTENT_PAGES.groups]: (path) => buildFlowStartedProps('admin_groups', path),
  [CONTENT_PAGES.managedEventTypes]: (path) => buildFlowStartedProps('admin_managed_events', path),
  [CONTENT_PAGES.managedWorkflows]: (path) => buildFlowStartedProps('admin_managed_workflows', path),
  [CONTENT_PAGES.meetings]: (path) => buildFlowStartedProps('meetings', path),
  [CONTENT_PAGES.routingForms]: (path) => buildFlowStartedProps('routing', path),
  [CONTENT_PAGES.users]: (path) => buildFlowStartedProps('admin_users', path),
  [CONTENT_PAGES.workflows]: (path) => buildFlowStartedProps('workflows', path),
  [CONTENT_PAGES.meetingTypes]: (path) => buildFlowStartedProps('meeting_types', path),
  [CONTENT_PAGES.singleUseLinks]: (path) => buildFlowStartedProps('single_use_links', path),
  [CONTENT_PAGES.polls]: (path) => buildFlowStartedProps('polls', path),
}

const buildPaywallShownProps = ({
  feature,
  plan = 'standard',
  type = 'popup'
}) => ({
  paywall_feature: feature,
  plan_required: plan,
  paywall_type: type
})
export const ANALYTICS_PAYWALL_SHOWN_PROPS_MAP = (type) => ({
  [CONTENT_PAGES.adminDashboard]: buildPaywallShownProps({ feature: 'admin_dashboard', type }),
  [CONTENT_PAGES.analyticsEvents]: buildPaywallShownProps({ feature: 'analytics_event', type }),
  [CONTENT_PAGES.analyticsMeetings]: buildPaywallShownProps({ feature: 'analytics_capacity', type }),
  [CONTENT_PAGES.analyticsRouting]: buildPaywallShownProps({ feature: 'analytics_routing_form', plan: 'teams', type }),
  [CONTENT_PAGES.groups]: buildPaywallShownProps({ feature: 'admin_user_groups', plan: 'teams', type }),
  [CONTENT_PAGES.managedEventTypes]: buildPaywallShownProps({ feature: 'admin_managed_events', plan: 'teams', type }),
  [CONTENT_PAGES.managedWorkflows]: buildPaywallShownProps({ feature: 'admin_managed_workflows', plan: 'teams', type }),
  [CONTENT_PAGES.routingForms]: buildPaywallShownProps({ feature: 'routing_forms', plan: 'teams', type }),
  [CONTENT_PAGES.users]: buildPaywallShownProps({ feature: 'admin_users', type }),
  [CONTENT_PAGES.workflows]: buildPaywallShownProps({ feature: 'workflows', type }),
})

const buildCtaShownProps = (context) => ({
  ...ANALYTICS_CTA_CLICK_PROPS_MAP[context],
  cta_destination: null
})
export const ANALYTICS_CTA_SHOWN_PROPS_MAP = {
  [CONTENT_PAGES.adminDashboard]: buildCtaShownProps(CONTENT_PAGES.adminDashboard),
  [CONTENT_PAGES.analyticsEvents]: buildCtaShownProps(CONTENT_PAGES.analyticsEvents),
  [CONTENT_PAGES.analyticsMeetings]: buildCtaShownProps(CONTENT_PAGES.analyticsMeetings),
  [CONTENT_PAGES.analyticsRouting]: buildCtaShownProps(CONTENT_PAGES.analyticsRouting),
  [CONTENT_PAGES.contacts]: buildCtaShownProps(CONTENT_PAGES.contacts),
  [CONTENT_PAGES.groups]: buildCtaShownProps(CONTENT_PAGES.groups),
  [CONTENT_PAGES.managedEventTypes]: buildCtaShownProps(CONTENT_PAGES.managedEventTypes),
  [CONTENT_PAGES.managedWorkflows]: buildCtaShownProps(CONTENT_PAGES.managedWorkflows),
  [CONTENT_PAGES.meetings]: buildCtaShownProps(CONTENT_PAGES.meetings),
  [CONTENT_PAGES.routingForms]: buildCtaShownProps(CONTENT_PAGES.routingForms),
  [CONTENT_PAGES.users]: buildCtaShownProps(CONTENT_PAGES.users),
  [CONTENT_PAGES.workflows]: buildCtaShownProps(CONTENT_PAGES.workflows),
  [CONTENT_PAGES.recaps]: buildCtaShownProps(CONTENT_PAGES.recaps),
  [CONTENT_PAGES.recapsMIEnabled]: buildCtaShownProps(CONTENT_PAGES.recapsMIEnabled),
}
